module.exports = __webpack_public_path__ + "img/linkedin.bd8f5ff4.svg";